import React, { Component } from 'react';
import $ from 'jquery';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import '@fullcalendar/react/dist/vdom';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction'; // needed for dayClick
import listPlugin from '@fullcalendar/list';
import allLocales from '@fullcalendar/core/locales-all';
import uniqWith from 'lodash/uniqWith';
import { stringToBoolean } from '../../utilities/conversionUtility';
import ExceededMessage from '../../components/ExceededMessage';
import Alert from '../../components/Alert';
import {
  getCalendarEvents, getProducts, getSchedules, getLocations,
} from '../../services/api';
import Select from '../../components/Common/Select';
import { customSelectStyles } from '../../utilities/helperUtility';
import Translation from '../../utilities/localizationUtility';
import BrandingString from '../components/BrandingString';
import { StyledGlobalWrapper } from "./CalendarPage.style";

dayjs.extend(isBetween);

const renderImage = (event, element) => {
  const parts = event.image.split('?');
  const image = parts[0];
  const index = image.lastIndexOf('.');
  const ext = image.substr(index);
  const path = image.substr(0, index);
  const div = $('<div>', { class: 'fc-thumb' });
  const img = $('<img>', { src: `${path}_small${ext}?_=${parts[1]}` });

  if (element.find('.fc-list-event-graphic').length > 0) {
    element.find('.fc-list-event-graphic').empty().append(div.append(img));
  } else if (element.find('.fc-event-title-container').length > 0) {
    element.find('.fc-event-title-container').append(div.append(img));
  } else {
    element.append(div.append(img));
  }
};

const renderIcon = (event, element) => {
  const cssClass = `fa ${event.icon}`;
  const i = $('<i>', { class: cssClass, css: { margin: '5px' } });
  element.prepend(i);
};

export default class CalendarPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      firstOccurrence: null,
      initialView: props.setting.default_view,
      products: [],
      product: false,
      variant: false,
      locations: [],
      location: false,
      tags: [],
      windowWidth: window.innerWidth,
    };

    this.onSelectProduct = this.onSelectProduct.bind(this);
    this.onSelectVariant = this.onSelectVariant.bind(this);
    this.fetchScheduledProducts = this.fetchScheduledProducts.bind(this);
    this.fetchAnnouncements = this.fetchAnnouncements.bind(this);
    this.eventRender = this.eventRender.bind(this);

    this.calendarComponentRef = React.createRef();
  }

  async fetchAllProducts() {
    const params = { scheduled: true, hidden: false };

    // Fetch first page to get total_pages
    const firstPage = await getProducts({ ...params, page: 1 });
    const allProducts = firstPage?.products || [];
    const totalPages = firstPage?.meta?.total_pages || 1;

    if (totalPages > 1) {
      // Fetch remaining pages in parallel
      const remainingPages = await Promise.all(
        Array.from({ length: totalPages - 1 }, (_, i) => getProducts({ ...params, page: i + 2 })),
      );

      remainingPages.forEach((pageData) => {
        if (pageData?.products) {
          allProducts.push(...pageData.products);
        }
      });
    }

    return allProducts;
  }

  async componentDidMount() {
    window.addEventListener('resize', this.handleResize.bind(this));
    try {
      const newState = {};

      const products = await this.fetchAllProducts();
      newState.products = products;

      const data2 = await getLocations();
      if (data2 && data2.locations) {
        newState.locations = [...data2.locations];
      }

      this.setState(newState);
    } catch (e) {
      console.log('error', e);
      throw e;
    }
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    const {
      setting: {
        show_location_filter: showLocationFilter,
        show_product_filter: showProductFilter,
        show_tag_filter: showTagFilter,
        show_remaining_spaces: showRemainingSpaces,
        default_view: defaultView,
      },
    } = this.props;

    if (defaultView !== prevProps.setting.default_view) {
      this.changeView(defaultView);
    }
    // Set filters to default if setting change
    const that = this;
    if (showProductFilter !== prevProps.setting.show_product_filter) {
      this.setState({ product: false, variant: false }, () => {
        that.refetchEvents();
      });
    }
    if (showLocationFilter !== prevProps.setting.show_location_filter) {
      this.setState({ location: false }, () => {
        that.refetchEvents();
      });
    }
    if (showTagFilter !== prevProps.setting.show_tag_filter) {
      this.setState({ tags: false }, () => {
        that.refetchEvents();
      });
    }
    if (showRemainingSpaces !== prevProps.setting.show_remaining_spaces) {
      this.setState({ tags: false }, () => {
        that.refetchEvents();
      });
    }
  }

  handleResize() {
    const { windowWidth } = this.state;
    const { innerWidth } = window;

    if (
      (windowWidth > 512 && innerWidth < 512)
      || (windowWidth < 512 && innerWidth > 512)
      || (windowWidth > 300 && innerWidth < 300)
      || (windowWidth < 300 && innerWidth > 300)
    ) {
      this.setState({ windowWidth: window.innerWidth });
    }
  }

  fetchScheduledProducts(timeObj, callback) {
    const { start, end } = timeObj;
    const today = new Date();
    const { product, variant, location, tags } = this.state;
    const { setting: { show_all_course_occurences: showAllCourseOccurrences } } = this.props;

    const params = {
      start: dayjs(start).format('YYYY-MM-DD'),
      end: dayjs(end).format('YYYY-MM-DD'),
      location: location ? location.id : '',
      tags: tags ? tags.join(',') : '',
      show_all_course_occurrences: showAllCourseOccurrences, // eslint-disable-line camelcase
      calendar: true,
    };

    const { exceededBookingsLimit, exceededTrialPlan } = this.props;
    if (product) {
      params.products = product.id;
      params.bta_id = '1'; // eslint-disable-line camelcase
    } else {
      params.handle = '';
    }

    params.variant = variant ? variant.id : '';

    if (!exceededBookingsLimit && !exceededTrialPlan) {
      getSchedules(params)
        .then((data) => {
          const { schedule } = data;

          let events = schedule.map((item) => {
            const elem = Object.assign(item, {
              start: new Date(
                item.start[0],
                item.start[1] - 1,
                item.start[2],
                item.start[3],
                item.start[4],
                item.start[5],
              ),
              end: new Date(
                item.end[0],
                item.end[1] - 1,
                item.end[2],
                item.end[3],
                item.end[4],
                item.end[5],
              ),
            });

            if (elem.start < today || elem.bookedOut) {
              delete elem.url;
            }
            return elem;
          });

          const { firstOccurrence } = this.state;
          const { first_occurrence: firstOccur } = data;
          if (firstOccur) {
            const occurrence = new Date(
              firstOccur[0],
              firstOccur[1] - 1,
              firstOccur[2],
              firstOccur[3],
              firstOccur[4],
              firstOccur[5],
            );

            if (!firstOccurrence && !dayjs(occurrence).isBetween(start, end)) {
              this.setState({ firstOccurrence: occurrence });
              const calendarApi = this.calendarComponentRef.current.getApi();
              calendarApi.gotoDate(occurrence);
            }
          }

          events = uniqWith(
            events,
            (arrVal, othVal) => (
              arrVal.url === othVal.url
              && dayjs(arrVal.start).isSame(othVal.start)
              && dayjs(arrVal.end).isSame(othVal.end)
            ),
          );

          callback(events);
        })
        .catch((e) => {
          console.log(e);
          callback([]);
        });
    }
  }

  fetchAnnouncements(timeObj, callback) {
    const { start, end } = timeObj;
    const { exceededBookingsLimit, exceededTrialPlan } = this.props;

    const params = {
      start: dayjs(start).format('YYYY-MM-DD'),
      end: dayjs(end).format('YYYY-MM-DD'),
    };

    if (!exceededBookingsLimit && !exceededTrialPlan) {
      getCalendarEvents(params)
        .then((data) => {
          const events = data.events.map((item) => ({
            start: new Date(
              item.start[0],
              item.start[1] - 1,
              item.start[2],
              item.start[3],
              item.start[4],
              item.start[5],
            ),
            end: new Date(
              item.end[0],
              item.end[1] - 1,
              item.end[2],
              item.end[3],
              item.end[4],
              item.end[5],
            ),
            allDay: item.all_day,
            backgroundColor: item.backgroundColor,
            textColor: item.textColor,
            title: item.title,
            hideSpace: true,
            url: item.url || '',
          }));
          callback(events);
        })
        .catch((e) => {
          console.log(e);
          callback([]);
        });
    }
  }

  eventClick(info) {
    const { el, view } = info;
    if (view.type === 'listMonth') {
      info.jsEvent.preventDefault();
      const eventLink = $(el).find('a');
      const href = eventLink.attr('href');
      if (href) window.open(href);
    }
  }

  eventRender(info) {
    const { event, el } = info;
    const { extendedProps } = event;
    const { setting: { show_image, show_remaining_spaces } } = this.props;
    const showImage = stringToBoolean(show_image);
    const today = new Date();
    const eventBackground = event.backgroundColor || '#fff';
    const eventColor = event.textColor || '#202223';
    const eventBorder = event.borderColor || '#e7eaec';

    if (!extendedProps) return;

    const element = $(el);
    const eventLink = element.find('a');

    element.attr('target', '_parent');
    if (eventLink.length) eventLink.attr('target', '_parent');
    if (event.end < today) element.addClass('past-event');

    if (stringToBoolean(show_remaining_spaces) && !extendedProps.hideSpace) {
      const children = element.children();
      const lastElement = children[children.length - 1];
      if (extendedProps.bookedOut) {
        element.addClass('booked-out');
        lastElement.append(...$('<br><small>Sold Out!</small>'));
      } else {
        const remaining = extendedProps.capacity - extendedProps.bookingCount;
        lastElement.append(
          ...$(`<br/><small>${remaining} spaces remaining</small>`),
        );
      }
    }

    element.find('.fc-event-title').css('text-overflow', 'ellipsis');
    element.css('color', eventColor)
      .css('background-color', eventBackground)
      .css('border', `1px solid ${eventBorder}`);

    if (extendedProps.image && showImage) {
      renderImage(extendedProps, element);
    }

    if (extendedProps.icon && showImage) {
      renderIcon(extendedProps, element);
    }
  }

  onSelectProduct(id) {
    const { products } = this.state;
    const product = products.find((p) => p.id === parseInt(id, 10));

    this.setState({ product }, () => {
      this.refetchEvents();
    });
  }

  onSelectVariant(id) {
    const { product } = this.state;
    const variant = product.variants.find((v) => v.id === parseInt(id, 10));

    this.setState({ variant }, () => {
      this.refetchEvents();
    });
  }

  onSelectLocation(id) {
    const { locations } = this.state;
    const location = locations.find((l) => l.id === parseInt(id, 10));

    this.setState({ location }, () => {
      this.refetchEvents();
    });
  }

  onTagsChange(value) {
    this.setState({ tags: value }, () => {
      this.refetchEvents();
    });
  }

  refetchEvents() {
    const calendarApi = this.calendarComponentRef.current.getApi();
    calendarApi.refetchEvents();
  }

  renderButtonStyle() {
    const { style } = this.props;
    const bgc = style.button && style.button.backgroundColor ? style.button.backgroundColor : 'black';
    const fc = style.button && style.button.color ? style.button.color : 'white';

    return (
      <style dangerouslySetInnerHTML={{
        __html: `
        .bta-calendar-widget .fc-button {
          color: ${fc} !important;
          background-color: ${bgc} !important;
        };
      `,
      }}
      />
    );
  }

  changeView(view) {
    const calendarApi = this.calendarComponentRef.current.getApi();
    calendarApi.changeView(view);
    this.setState({ initialView: view });
  }

  render() {
    const self = this;
    const { initialView, location, locations, products, product, variant } = this.state;
    const {
      all_tags: allTags = [],
      exceededBookingsLimit,
      exceededTrialPlan,
      messages,
      region,
      setting,
      style,
      brandingVisualized,
    } = this.props;

    const exceeded = exceededBookingsLimit || exceededTrialPlan;
    const views = {
      dayGridMonth: { buttonText: 'Month' },
      timeGridWeek: { buttonText: 'Week' },
      timeGridDay: { buttonText: 'Day' },
      listMonth: { buttonText: 'List' },
    };
    const t = new Translation(this.props);
    const showLocationFilter = stringToBoolean(setting.show_location_filter);
    const showProductFilter = stringToBoolean(setting.show_product_filter);
    const showTagFilter = stringToBoolean(setting.show_tag_filter);

    const productOptions = [
      { value: '', label: 'All products' },
      ...products.map((p) => ({ value: p.id, label: p.title })),
    ];
    const variantOptions = [
      { value: '', label: 'All variants' },
      ...(product ? product.variants.map((v) => ({ value: v.id, label: v.title })) : []),
    ];
    const locationOptions = [
      { value: '', label: 'All locations' },
      ...locations.map((l) => ({ value: l.id, label: l.name })),
    ];
    const tagOptions = allTags.map((tag) => ({ value: tag, label: tag }));

    return (
      <StyledGlobalWrapper styles={style}>
        <div
          className="widget-calendar-page-container"
          style={{
            ...style.body,
            ...style.boxShadow,
          }}
        >
          {this.renderButtonStyle()}
          <h3 className="widget-title" style={{ ...style.title }}>{t.key('title')}</h3>

          {exceeded && (
            <Alert
              unclosed
              messages={[<ExceededMessage message={messages.message_booking_limit_reached} />]}
              type="exceeded-trial-plan"
              disableIcon
            />
          )}

          {products.length > 0 && showProductFilter && (
            <>
              <div className="select-block">
                <span className="titles" style={{ ...style.body }}>Product</span>
                <Select
                  menuPlacement="bottom"
                  styles={customSelectStyles(style.select)}
                  inputId="bta-product-select"
                  name="product"
                  value={product?.id || ''}
                  options={productOptions}
                  onChange={this.onSelectProduct}
                />
              </div>
              {product && (
                <div className="select-block">
                  <span className="titles" style={{ ...style.body }}>Type</span>
                  <Select
                    menuPlacement="bottom"
                    styles={customSelectStyles(style.select)}
                    inputId="bta-variant-select"
                    name="variant"
                    value={variant?.id || ''}
                    options={variantOptions}
                    onChange={this.onSelectVariant}
                  />
                </div>
              )}
            </>
          )}

          {showLocationFilter && (
            <div className="select-block">
              <span className="titles" style={{ ...style.body }}>Location</span>
              <Select
                menuPlacement="bottom"
                styles={customSelectStyles(style.select)}
                inputId="bta-location-select"
                name="location"
                value={location?.id || ''}
                options={locationOptions}
                onChange={(x) => this.onSelectLocation(x)}
              />
            </div>
          )}

          {showTagFilter && (
            <div className="select-block">
              <span className="titles" style={{ ...style.body }}>Tags</span>
              <Select
                allowSelectOption
                menuPlacement="bottom"
                styles={customSelectStyles(style.select)}
                inputId="bta-tags-select"
                isMulti
                name="tags"
                options={tagOptions}
                onChange={(x) => this.onTagsChange(x)}
              />
            </div>
          )}

          <div className="fullcalendar-wrapper bta-calendar-widget">
            <FullCalendar
              plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin]}
              ref={this.calendarComponentRef}
              initialView={initialView}
              contentHeight="auto"
              buttonText={{
                today: t.key('today') || 'Today',
              }}
              eventTimeFormat={{
                hour: 'numeric',
                minute: '2-digit',
                meridiem: 'short',
              }}
              datesSet={(info) => {
                const { view } = info;
                if (self.state.initialView !== view.type) {
                  self.setState({ initialView: view.type });
                }
              }}
              views={views}
              headerToolbar={{
                left: 'prev,next today',
                center: 'title',
                right: '',
              }}
              loading={(isLoading) => {
                // Update location dropdown via class toggle
                document.getElementById('bta-location-select')
                  ?.closest('.select-block')
                  ?.classList.toggle('bta-loading-disabled', isLoading);

                if (isLoading) {
                  $('#bta-loading').fadeIn();
                } else {
                  $('#bta-loading').fadeOut();
                }
              }}
              eventSources={[
                { events: this.fetchScheduledProducts },
                { events: this.fetchAnnouncements },
              ]}
              eventClick={this.eventClick}
              eventDidMount={this.eventRender}
              allDaySlot={false}
              locales={allLocales}
              locale={region}
            />
            <span id="bta-loading" className="loading" style={{ display: 'none', float: 'left' }}>Loading...</span>
            {brandingVisualized && <BrandingString />}
          </div>
        </div>
      </StyledGlobalWrapper>
    );
  }
}
